module.exports = __webpack_public_path__ + "static/media/result_ns_ja.4e0dc8ee.jpg";